export const getLoadingStatus = (state) => state.students.isLoading;
export const getStudents = state => state.students.students;
